<script>
import styled from '@u-rogel/vue-emotion'

export default styled.div`
  display:flex;
  align-items: center;
  gap: 1rem;
`()
</script>
